<script>
    export let width;
    export let height;
  </script>
  
<div style={`width: ${width + "px"}; height: ${height + "px"}`} class="spinner-container">
<img src="img/tail-spin.svg" alt="Loading spinner" width={width/2} height={height/2}/>
</div>

<style>
  div.spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>